import React from "react";

export const modalWorkerNameStyle: React.CSSProperties = { fontWeight: 600 };

export const modalReasonTypeStyle: React.CSSProperties = {
  marginTop: "18px",
  marginBottom: "18px",
  fontWeight: 600,
  marginLeft: "5px",
};
